export default __webpack_public_path__ + "static/media/miasto.40c41d2c.svg";